<template>
    <div>
        <!-- ============================================================== -->
        <!-- Bread crumb and right sidebar toggle -->
        <!-- ============================================================== -->
        <div class="page-breadcrumb border-bottom">
            <div class="row">
                <div class="col-lg-3 col-md-4 col-xs-12 align-self-center">
                    <h5 class="mb-0 font-medium text-uppercase">
                        <router-link to="/apps/template-communities" class="text-center navbar-brand">
                            <strong>
                                <i class="fas fa-chevron-left"></i> Back
                            </strong>
                        </router-link>
                        <span>Edit Template</span>
                    </h5>
                </div>
                <div class="col-lg-9 col-md-8 col-xs-12 align-self-center">
                    <nav aria-label="breadcrumb" class="float-left mt-2 float-md-right">
                        <ol class="p-0 mb-0 breadcrumb justify-content-end">
                            <li class="breadcrumb-item">
                                <a>Home</a>
                            </li>
                            <li class="breadcrumb-item">
                                <router-link to="/apps/templates">Templates</router-link>
                            </li>
                            <li class="breadcrumb-item active" aria-current="page">{{ presentation.id }}</li>
                        </ol>
                    </nav>
                </div>
            </div>
        </div>
        <!-- ============================================================== -->
        <!-- End Bread crumb and right sidebar toggle -->
        <!-- ============================================================== -->
        <!-- ============================================================== -->
        <!-- Container fluid  -->
        <!-- ============================================================== -->
        <div class="page-content container-fluid">
            <!-- ============================================================== -->
            <!-- Start Page Content -->
            <!-- ============================================================== -->
            <div class="card">
                <div class="card-body">
                    <form class="col-md-6" @submit.prevent="submit">
                        <div class="form-group row">
                            <label class="col-sm-4 col-form-label">Name</label>

                            <div class="col-sm-8">
                                <input
                                        readonly
                                        type="text"
                                        class="form-control"
                                        v-model="presentation.name"
                                />
                            </div>
                        </div>
                        <div class="form-group row">
                            <label class="col-sm-4 col-form-label">Slug</label>

                            <div class="col-sm-8">
                                <input
                                        type="text"
                                        class="form-control"
                                        v-model="presentation.slugifiedName"
                                />
                            </div>
                        </div>
                        <div class="form-group row">
                            <label class="col-sm-4 col-form-label">Description</label>

                            <div class="col-sm-8">
                <textarea
                        readonly
                        type="text"
                        class="form-control"
                        rows="3"
                        v-model="presentation.description"
                ></textarea>
                            </div>
                        </div>
                        <div class="form-group row">
                            <label class="col-sm-4 col-form-label">Keyword</label>

                            <div class="col-sm-8">
                                <input
                                        type="text"
                                        class="form-control"
                                        v-model="presentation.keyword"
                                >
                            </div>
                        </div>
                        <div class="form-group row">
                            <label class="col-sm-4 col-form-label">For who</label>

                            <div class="col-sm-8">
                                <input
                                        type="text"
                                        class="form-control"
                                        v-model="presentation.forWho"
                                >
                            </div>
                        </div>
                        <div class="form-group row">
                            <label class="col-sm-4 col-form-label">CTA</label>

                            <div class="col-sm-8">
                                <select class="form-control" v-model="presentation.cta">
                                    <option value="Best">Best</option>
                                    <option value="Hot">Hot</option>
                                    <option value="Latest">Latest</option>
                                    <option value="Popular">Popular</option>
                                </select>
                            </div>
                        </div>
                        <div class="form-group row">
                            <label for="isIndexBot" class="col-sm-4 col-form-label">Index Bot</label>
                            <div class="col-sm-8">
                                <input type="checkbox" name="isIndexBot" v-model="presentation.isIndexBot">
                            </div>
                        </div>
                        <div class="form-group row">
                            <label for="categories" class="col-sm-4 col-form-label">Categories</label>
                            <div class="col-sm-8">
                                <multiselect v-model="categorySelected" tag-placeholder="Add this as new tag"
                                             placeholder="Search or add a tag"
                                             label="name" track-by="id" :options="categoryOptions" :multiple="true"
                                             :taggable="true"></multiselect>
                            </div>
                        </div>
                        <div class="text-center form-group">
                            <button
                                    class="btn btn-primary btn-sm"
                                    type="submit"
                                    style="margin-left: 10px"
                            >Save changes <i class="fa fa-spin fa-spinner" v-if="submiting"></i></button>
                        </div>

                    </form>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
// @ is an alias to /src
import Config from "@/config";
import Multiselect from 'vue-multiselect'

export default {
  name: "TemplateDetail",
  components: {
    Multiselect
  },
  data() {
    return {
      presentation: {},
      submiting: false,
      categorySelected: [],
      categoryOptions: [],
    };
  },
  created() {
  },
  mounted() {
    this.init()
  },
  methods: {
    async init() {
      // this.id = this.$route.params.id;
      this.getListCategories()
      const resp = await this.$http.get(`${Config.api.adminGetPresentationDetail}${this.$route.params.id}`)
      this.presentation = resp.body
      this.handlePresentationCategoriesSeleted()
    },
    handlePresentationCategoriesSeleted() {
      if (this.presentation) {
        this.presentation.PresentationsCategories.forEach((item) => {
          this.categorySelected.push({
            name: item.Category && item.Category.name,
            id: item.Category && item.Category.id,
          })
        })
      }
    },
    async getListCategories() {
      let params = {
        page: 1,
        limit: 1000,
        sortBy: this.sortBy,
        sortDesc: this.sortDesc,
      };
      const res = await this.callApiGetListCategories(params)
      if (!res || res.status !== 200) {
        this.$toasted.error('Error get data list categories!')
        return false
      }
      this.categoryOptions = res.body.data
    },
    async callApiGetListCategories(params) {
      try {
        return await this.$http
          .get(Config.api.getPresentationCategories, {
            params: params
          });
      } catch (e) {
        console.log(e)
        return false
      }
    },
    appendCategoryIds() {
      const categoryIds = []
      if (this.categorySelected.length) {
        this.categorySelected.forEach((objCategory) => {
          categoryIds.push(objCategory.id)
        })
        return categoryIds;
      }
      return categoryIds
    },
    async submit() {
      if (this.submiting) return
      this.submiting = true
      this.presentation.publicSource = ''
      this.presentation.categoryIds = this.appendCategoryIds()
      try {
        await this.$http.put(`${Config.api.adminUpdatePresentation}${this.presentation.id}`, this.presentation);
      } catch (e) {
        this.submiting = false
        this.$toasted.error('Error update presentation', {duration: 5000});
        return false
      }
      await this.$http.post(Config.api.publishPresentation, {
        presentationIds: [this.presentation.id],
        isAdmin: true
      })
      this.submiting = false
      this.$toasted.success('Updated presentation!', {duration: 1000});
    }
  }
};

</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style lang="scss" scoped>
.description {
  display: inline-block;
  max-height: 100px;
  max-width: 350px;
  overflow: auto;
}

.break-any {
  word-wrap: anywhere;
}

.small-text {
  font-size: 12px;
  color: #888;
}
</style>
